import * as React from "react";
const NewsSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 1v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5h-4"
    />
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 1h14v14a2 2 0 0 0 2 2M11 5H5m6 4H7"
    />
  </svg>
);
export default NewsSVG;
